import { appConfig } from "@/config/app.config";

export type PlanType = "basic" | "pro" | "custom";

export const DEFAULT_VIDEO_SRC = appConfig.links.onboardingVideo;
export const DEFAULT_VIDEO_POSTER = "/assets/onboarding/welcome-video-poster.svg";

export const PLAN_CONFIG: Record<
  PlanType,
  {
    badge: string;
    title: string;
    subtitle: string;
  }
> = {
  basic: {
    badge: "Basic",
    title: "Dein Zugang ist startklar",
    subtitle: "Wir zeigen dir jetzt den schnellsten Weg zu deinem ersten Post.",
  },
  pro: {
    badge: "Pro",
    title: "Dein Workspace ist bereit",
    subtitle: "Wir führen dich direkt zu deinem ersten Beitrag mit allen wichtigen Schritten.",
  },
  custom: {
    badge: "Custom",
    title: "Dein Setup ist live",
    subtitle: "Wir zeigen dir die wichtigsten Handgriffe, damit du direkt produktiv loslegst.",
  },
};
